import { useEffect, useState, useRef, useCallback } from 'react';
import { dispatcher } from 'dispatcher';
import { useRequestAnimationFrame } from '@theme/js/hooks/swiss/useRequestAnimationFrame';

export const useShouldAnimateOnOpen = () => {
    const [shouldAnimate, setShouldAnimate] = useState(true);
    const [isOpen, setIsOpen] = useState(false);
    const alreadyAnimatedRef = useRef(false);

    const handleOpen = useRequestAnimationFrame(useCallback(() => {
        setIsOpen(true);
    }, []));

    const handleClose = useRequestAnimationFrame(useCallback(() => {
        setIsOpen(false);
    }, []));

    const resetAnimateOnOpen = useRequestAnimationFrame(useCallback(() => {
        setShouldAnimate(false);
    }, []));

    useEffect(() => {
        dispatcher.listen('openGamesInfoPopupAction', handleOpen);
        dispatcher.listen('closeGamesInfoPopupAction', handleClose);

        return () => {
            dispatcher.removeListener('openGamesInfoPopupAction', handleOpen);
            dispatcher.removeListener('closeGamesInfoPopupAction', handleClose);
        };
    }, [handleClose, handleOpen, shouldAnimate]);

    useEffect(() => {
        if (isOpen && !alreadyAnimatedRef.current) {
            setShouldAnimate(true);
            alreadyAnimatedRef.current = true;
        }
    }, [isOpen]);

    return { shouldAnimateOnOpen: shouldAnimate, resetAnimateOnOpen };
};
